import React from 'react';
import { Icon } from '@hvcgroep/design-system';
import c from 'classnames';
import './style.scss';
import { IconsId } from '@hvcgroep/design-system/dist/types/icons';

interface Props {
  status: 'success' | 'pending' | 'end';
  text?: string;
  textPosition?: 'before' | 'after'
  useColoredText?: boolean;
}

/** @TODO: add the other cases */
const StatusIcon: React.FC<Props> = ({
  status,
  useColoredText,
  text,
  textPosition = 'after',
}) => {
  const [icon, variant]: [IconsId, string] = React.useMemo(() => {
    /** @todo also catch the other cases */
    switch (status) {
      case 'success':
        return ['check_circle', 'dark-green'];
      case 'pending':
        return ['schedule', 'red-grey'];
      case 'end':
        return ['block', 'red-grey'];
      default:
        return ['block', 'red-grey'];
    }
  }, [status]);

  const classes = c('mo-status-icon', {
    'mo-status-icon--colored-text': status === 'success',
  });

  return (
    <div className={classes}>
      {(text && textPosition === 'before') && text}
      <Icon className="mo-status-icon" icon={icon} variant={variant} />
      {(text && textPosition === 'after') && text}
    </div>
  );
};

export default StatusIcon;
